export const getFilters = () => {
    const is_gsc_report = window.gsc_report || window.location.pathname.includes('gsc-reports');
    const filters = window.localStorage.getItem(is_gsc_report ? 'gsc-filters' : 'filters');

    return filters;
};
